import { render, staticRenderFns } from "./livro-matricula.vue?vue&type=template&id=2c0b2300"
import script from "./livro-matricula.vue?vue&type=script&lang=js"
export * from "./livro-matricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports